import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { AnimationOnScroll } from "react-animation-on-scroll";
import loadable from "@loadable/component"

import ContentModule from "../../modules/content_module";
//import ReviewRatings from "../../modules/review_rating_module";
import BannerSearch from "./Section/BannerSearch";
import BannerBtns from "./Section/BannerBtns";

import ValuationPage from "../ValuationPage/ValuationPage"
import FormsWrapper from "../FormPage/FormPage";
import ImageModule from "../../modules/image_module";

//import LeadooScript from "../LeadooScript/LeadooScript";

import { breadcrumbs } from "../../common/utils/breadcrumbs";

const LeadooScript = loadable(() =>
  import("../LeadooScript/LeadooScript")
)
const ReviewRatings = loadable(() =>
  import("../../modules/review_rating_module")
)

import "./Banner.scss";
import { Link } from "gatsby";


const Banner = ({banner_section, GQLModules, GQLPage, location}) => {

  //console.log("banner_section", banner_section);

  const breadcrumbsList = breadcrumbs(GQLPage.menu);

  const [window_wdth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0)


  const ImageRenderList = ({banner_section, altText}) => {
    var imagename = "pages.banner_section_banner_image.landing_banner_image";

    let image_name = imagename;
    let image_src = banner_section.banner_image
    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.banner_section_banner_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.banner_section_banner_image_Transforms;
    }

    if(window_wdth < 768){
      if(banner_section?.mobile_banner_image){
        image_src = banner_section.mobile_banner_image;
        image_name = "pages.banner_section_mobile_banner_image.mobile_banner_image";
        if (GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms) {
          processedImages = GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms;
        }
      }
    }
    
    return (
      GQLPage.page_class === "life_landlord_banner" ?
        <ImageModule ImageSrc={image_src} altText={altText} renderer="bgImg" strapi_id={GQLPage?.id} classNames="banner_img" />
      :
        <ImageModule ImageSrc={image_src} altText={altText} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="bgImg" imagename={image_name} strapi_id={GQLPage?.id} classNames="banner_img" />
    )
  }

  //console.log("GQLModules", GQLModules, (GQLPage?.choose_form === "none" || GQLPage?.choose_form === undefined))

  return (

      // <section className={`banner ${banner_section?.banner_style}`}>
      <>
        {(process.env.GATSBY_SITE_NAME === "Brandvaughan" || process.env.GATSBY_SITE_NAME === "Michael Jones" || process.env.GATSBY_SITE_NAME === "Chase Evans") && GQLPage.layout === "form_template" && 
        <div className="breadcrumb-section">
          <Container>
            <Breadcrumb>
                {/* <Breadcrumb.Item href="javascript:;" className="d-none">Back to Branch Details</Breadcrumb.Item> */}
                <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                {breadcrumbsList?.map((breadcrumb, i, arr) => {
                    if (arr.length - 1 === i) { // is the last item in the array
                        return (
                            <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                        )
                    } else {
                        return (
                            <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                        )
                    }
                })}
            </Breadcrumb>
          </Container>
        </div>
        }

        <section className={`banner ${banner_section?.banner_style}`}>
          
          <div className="banner_wrapper">
            {/* <span className="banner_img" style={{backgroundImage:`url(${banner_section?.banner_image?.url})`}}></span> */}
            {banner_section?.banner_image &&
              <>
              <ImageRenderList banner_section={banner_section} altText={banner_section?.title}  />
              </>
            }    
            <span className="transp_bg"></span>
          </div>

          <Container>
            <Row>
              <Col className="md-12">
                
                {(GQLPage?.choose_form === "none" || GQLPage?.choose_form === undefined) ?
                      <>
                        {(banner_section?.title || banner_section?.content || GQLModules?.length > 0) && 
                          <div className="banner-content position-relative">

                            {banner_section?.title && <h1>{banner_section.title}</h1> }

                            {banner_section?.content && 
                            <span className="sm-text">
                              <ContentModule Content={banner_section.content}/>
                            </span>
                            }

                            <div className="banner_container">
                              <Container>
                                {(banner_section?.button_cta_1?.label || banner_section?.button_cta_2?.label) && 
                                  <BannerBtns banner_section={banner_section} strapi_id={GQLPage?.id}/>
                                }

                                {banner_section?.show_search === "property_search" && 
                                  <BannerSearch GQLPage={GQLPage} />
                                }
                                
                                {(banner_section?.show_reviews && (process.env.GATSBY_TrustpilotBussinessID || process.env.GATSBY_TRUSTPILOT_BUSSINESS_ID)) && 
                                  <ReviewRatings />
                                }
                              </Container>
                            </div>

                            {GQLModules?.length > 0 && GQLModules.map((Module, index) => {

                              //console.log("Module ==>", Module)
                              return(
                                  <>
                                      {Module.__typename === "GLSTRAPI_ComponentComponentsValuationSection" && <ValuationPage key={Module} Module={Module} GQLPage={GQLPage} /> }

                                      {Module.__typename === "GLSTRAPI_ComponentComponentsLeadooChatComponent" && <LeadooScript key={Module} Module={Module} type="banner"/> }
                                  </>              
                              )
                            })}
                            
                          </div>
                        }
                      </>                  
      
                  :
                    <>
                      {/* {GQLPage?.choose_form === "valuation" && (
                        (banner_section?.title || banner_section?.content || GQLModules?.length > 0) && 
                            <div className="banner-content position-relative">

                              {banner_section?.title && <h1>{banner_section.title}</h1> }

                              {banner_section?.content && 
                                <span className="sm-text">
                                  <ContentModule Content={banner_section.content}/>
                                </span>
                              }
                            </div>
                      )} */}

                      <FormsWrapper form_data={banner_section} form_type={GQLPage?.choose_form} location={location} to_email_id={GQLPage?.form_to_email_id} menu_slug={GQLPage?.menu?.slug} description={GQLPage?.content} title={GQLPage?.title} GQLModules={GQLModules} banner_image={GQLPage?.email_banner?.url} />
                    </>

                }

              </Col>
            </Row>
          </Container>

         
        </section>
      </>
  );
};
export default Banner;
